module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"warning-msg":"No records available."},"ar":{"warning-msg":"لا توجد سجلات متاحة."}}')
  delete Component.options._Ctor
}
